<template>
  <v-app class="custom_bg">
    <NavBar v-if="$route.meta.showHeader == true" class="d-print-none" />
    <v-main>
      <v-slide-x-transition mode="out-in">
        <router-view />
      </v-slide-x-transition>
    </v-main>
  </v-app>
</template>

<script>
import NavBar from "./components/NavBar.vue";
export default {
  components: {
    NavBar,
  },
  name: "App",

  data: () => ({
    //
  }),
};
</script>
<style scoped >

</style>

